import React from 'react';
import Shield from '../../../../assets/images/shield.svg';
import Safari from '../../../../assets/images/safari.svg';
import HomeUser from '../../../../assets/images/home-user.svg';
import type { OnboardingSummary } from '../../../../types/onboarding';
import useOnboardingSummary from '../../../../hooks/useOnboardingSummary';

interface SectionSixProps {
  section: OnboardingSummary;
}

const SectionSix = ({ section }: SectionSixProps) => {
  const { idealPartnerProfile, partnershipType } = useOnboardingSummary({
    section,
  });
  return (
    <div>
      <div className='font-bold text-body-400 mb-4 flex items-center gap-2 mt-6'>
        <img
          className='w-6 h-6 object-contain'
          src={Shield}
          alt='Primary Goal'
        />
        Primary Goal:
      </div>
      <div className='text-lg mb-6'>
        Exploring strategic partnerships or collaborations
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={HomeUser}
              alt='HomeUser'
            />{' '}
            Kind of collaboration are you seeking:
          </div>
          <div className='text-lg'>
              {partnershipType}
          </div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img className='w-6 h-6 object-contain' src={Safari} alt='Safari' />{' '}
            Ideal partner profile:
          </div>
          <div className='text-lg'>
            {idealPartnerProfile}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionSix;
